module.exports = __webpack_public_path__ + "img/t3-10.40ac656d.svg";